export const defaultProfileSignature = 'token带走了我的余额，但是留下了生产力的痕迹。'

interface RewardAvatar { label?: string; background_color?: string }
interface RewardBackground { start_color?: string; end_color?: string }

export interface AvatarProfilePresentation {
  avatar_color?: string
  selected_reward_avatar?: RewardAvatar | null
  reward_avatar?: RewardAvatar | null
}

export interface BackgroundProfilePresentation {
  background_color?: string
  selected_reward_background?: RewardBackground | null
  reward_background?: RewardBackground | null
}

export function maskedProfileEmail(email = '') {
  const [local = '', domain = ''] = String(email).split('@')
  if (!domain) return email || '-'
  return `${local.slice(0, 1) || '*'}***${local.slice(-1) || '*'}@${domain}`
}

export function playerAvatarLabel(email = '') {
  const local = String(email).split('@')[0].replace(/\*/g, '').trim()
  const first = Array.from(local)[0] || '创'
  return `${first.toLocaleUpperCase()}*`
}

export function safeAvatarColor(value?: string, fallback = '#4b5563') {
  return /^#[0-9a-f]{6}$/i.test(String(value || '')) ? String(value).toLowerCase() : fallback
}

export function playerAvatarPresentation(email: string, profile: AvatarProfilePresentation = {}) {
  const reward = profile.selected_reward_avatar || profile.reward_avatar
  return {
    label: reward?.label || playerAvatarLabel(email),
    color: safeAvatarColor(reward?.background_color || profile.avatar_color),
  }
}

export function profileBackgroundPresentation(profile: BackgroundProfilePresentation = {}) {
  const reward = profile.selected_reward_background || profile.reward_background
  const fallback = safeAvatarColor(profile.background_color, '#eaf2ff')
  const start = safeAvatarColor(reward?.start_color, fallback)
  const end = safeAvatarColor(reward?.end_color, start)
  const background = reward?.start_color && reward?.end_color ? `linear-gradient(135deg, ${start}, ${end})` : fallback
  const red = Number.parseInt(start.slice(1, 3), 16)
  const green = Number.parseInt(start.slice(3, 5), 16)
  const blue = Number.parseInt(start.slice(5, 7), 16)
  return { background, dark: (red * 299 + green * 587 + blue * 114) / 1000 < 130 }
}
